import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getSiteInfo, subscribeNewsletter } from "../services/apiService";
import { API_BASE_URL } from "../config/api";
import toast from "react-hot-toast";

const Footer = () => {
  const [siteInfo, setSiteInfo] = useState({});
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  

  // Newsletter submit handler
  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    if (!newsletterEmail) {
      toast.error("Please enter your email");
      return;
    }

    try {
      setSubmitting(true);
      await subscribeNewsletter(newsletterEmail);
      toast.success("Thank you for subscribing!");
      setNewsletterEmail("");
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          "Failed to subscribe. Please try again later."
      );
    } finally {
      setSubmitting(false);
    }
  };
  const whatsappNumber = siteInfo.contact_phone
  ? siteInfo.contact_phone.replace(/\D/g, "")
  : "";

  // Fetch site info once
  useEffect(() => {
    const fetchSiteInfo = async () => {
      try {
        const response = await getSiteInfo();
        const data = response?.data || response;

        const infoObj = {};
        if (Array.isArray(data)) {
          data.forEach((item) => {
            infoObj[item.type] = item.value;
          });
        }

        setSiteInfo(infoObj);
      } catch (error) {
        console.error("Error fetching site info:", error);
      }
    };

    fetchSiteInfo();
  }, []);

  return (
    <footer>
      <div className="footer-sec">
        <div className="container-fluid add-padding">
          {/* Newsletter */}
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-7 col-md-8 col-sm-11 col-12">
              <div className="footer-newsletter">
                <h2>Stay Inspired – Sign Up Today</h2>
                <form onSubmit={handleNewsletterSubmit}>
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={newsletterEmail}
                    onChange={(e) => setNewsletterEmail(e.target.value)}
                    required
                  />
                  <div className="footer-latest-update-btn">
                    <button type="submit" disabled={submitting}>
                      <i className="fa-solid fa-paper-plane"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          {/* Main footer content */}
          <div className="row custom-border">
            {/* Quick Links */}
            <div className="col-lg-3 col-md-3 col-12">
              <div className="footer-support">
                <h2>Quick Links</h2>
                <ul>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  <li>
                    <Link to="/services">Services</Link>
                  </li>
                  <li>
                    <Link to="/projects">Gallery</Link>
                  </li>
                  <li>
                    <Link to="/blog">Blogs</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact Us</Link>
                  </li>
                       <li>
                    <Link to="/livegallery">Live Gallery</Link>
                  </li>
                  <li>
                    <Link to="/enquire">Enquire</Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Logo & Social */}
            <div className="col-lg-6 col-md-6 col-12">
              <div className="footer-logo">
                <Link to="/">
                  <img
                    src={
                      siteInfo.footer_logo
                        ? `${API_BASE_URL}/uploads/site-settings/${siteInfo.footer_logo.replace(
                            "/uploads/",
                            ""
                          )}`
                        : "/images/footer_logo176071690649.png"
                    }
                    alt={siteInfo.site_name || "The Design Showroom by LUXE"}
                  />
                </Link>
                <p>
                  {siteInfo.footer_about ||
                    "DISCOVER CURATED COLLECTIONS FROM DÉCOR, CUSTOM LIGHTING, FURNISHING, MARBLE AND MORE – FOR EVERY CORNER OF YOUR HOME"}
                </p>
                <ul className="footer-social">
                  {siteInfo.facebook_url && (
                    <li>
                      <a
                        href={siteInfo.facebook_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>
                  )}
                  {siteInfo.linkedin_url && (
                    <li>
                      <a
                        href={siteInfo.linkedin_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                    </li>
                  )}
                  {siteInfo.twitter_url && (
                    <li>
                      <a
                        href={siteInfo.twitter_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-x-twitter"></i>
                      </a>
                    </li>
                  )}
                  {siteInfo.instagram_url && (
                    <li>
                      <a
                        href={siteInfo.instagram_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-instagram"></i>
                      </a>
                    </li>
                  )}
                  {whatsappNumber && (
                      <li>
                        <a
                          href={`https://wa.me/${whatsappNumber}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="WhatsApp"
                        >
                          <i className="fab fa-whatsapp"></i>
                        </a>
                      </li>
                    )}
                </ul>
              </div>
            </div>

            {/* Contact Info */}
            <div className="col-lg-3 col-md-3 col-12">
              <div className="footer-latest-update">
                <h2>Contact Info</h2>
                <ul>
                  {siteInfo.contact_address && (
                    <li>
                      <a
                        href={siteInfo.map_url || "https://www.google.com/maps"}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-solid fa-location-dot"></i>{" "}
                        <span>{siteInfo.contact_address}</span>
                      </a>
                    </li>
                  )}
                  {siteInfo.contact_email && (
                    <li>
                      <a href={`mailto:${siteInfo.contact_email}`}>
                        <i className="fa-solid fa-envelope"></i>
                        <span>{siteInfo.contact_email}</span>
                      </a>
                    </li>
                  )}
                  {siteInfo.contact_phone && (
                    <li>
                      <a
                        href={`tel:${siteInfo.contact_phone.replace(
                          /\s/g,
                          ""
                        )}`}
                      >
                        <i className="fa-solid fa-phone"></i>
                        <span>{siteInfo.contact_phone}</span>
                      </a>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="container-fluid add-padding">
          <div className="footer-copy-right-sec">
            <div className="row">
              <div className="col-lg-6 col-md-7 col-12">
                <p
                  className="wow fadeInDown"
                  data-wow-duration="2s"
                  style={{ textAlign: "left" }}
                >
                  {siteInfo.copyright_text}
                </p>
              </div>
              <div className="col-lg-6 col-md-5 col-12">
                <ul className="ftr-lnks">
                  <li>
                    <Link to="/terms_and_conditions">
                      Terms &amp; Conditions
                    </Link>
                  </li>
                  <li>
                    <Link to="/cookie_policy">Cookies Policy</Link>
                  </li>
                  <li>
                    <Link to="/gdpr_policy">GDPR Policy</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
